import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
//service
import {UserService} from './service/user.service';

@Injectable()
export class AuthCodeGuard implements CanActivate {
  public currentUser;

  constructor(private login: UserService,
              private router: Router,
              private userService: UserService) {
  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const time = new Date();

    this.currentUser = this.userService.currentUser;
    if (!this.userService.isLoggedFullIn() || (time.getTime() > JSON.parse(localStorage.getItem('logout_timeout')))) {
      if ((JSON.parse(localStorage.getItem('logout_timeout'))) && (time.getTime() > JSON.parse(localStorage.getItem('logout_timeout')))) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('code_token');
        localStorage.removeItem('current_user');
        localStorage.removeItem('logout_timeout');
      }
      this.router.navigate(['/login']);
    } else {

      if (this.currentUser !== undefined) {

        // superadmin
        if (this.currentUser.role === 'superadmin') {
          if (next.params.org) { // organizations page
            return true;
          }
        }

        // admin
        if (this.currentUser.role === 'admin') {
          if (next.params.org) { // organizations page
            return true;
          }
        }

        // user
        if (this.currentUser.role === 'user') {
          if (next.params.org) { // organizations page
            this.router.navigate(['/main']);
            return false;
          }
        }
      }
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/authcodeguard.guard.ts